import { Card } from '@com-delta-idp/mnx-skymiles-shared';
import { Offers } from '../models/offers.interfaces';

export const CardsMocks: Card[] = [
  {
    id: 'earnMilesWithLyft',
    type: 'base',
    content: {
      title: 'Earn Miles With Lyft',
      subtitle: 'Earn 2 miles per $1 on all U.S. airport rides'
    },
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/logo/lyft-logo.svg',
      alt: 'Earn Miles With Lyft image'
    },
    image2: {
      alt: 'Earn Miles With Lyft image',
      show: true,
      src: '/content/dam/nextgen/standard-enrollment/content-fragments/pe/promotional-cards/isometric_car_v1.png'
    },
    tag: {
      title: 'LIMITED TIME OFFER'
    },
    action: {
      type: 'text',
      link: {
        label: 'More Details',
        url: 'https://www.deltalyft.com/content/delta-lyft/en/terms-and-conditions.html'
      }
    }
  },
  {
    id: '2XMiles',
    type: 'base',
    content: {
      title: '2X Miles for 6 Months',
      subtitle: 'Earn double miles for every flight up until July 2023.'
    },
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/promocards/2x-miles.svg',
      alt: '2X Miles for 6 Months image'
    },
    image2: {
      alt: '2X Miles for 6 Months image',
      show: true,
      src: '/content/dam/nextgen/standard-enrollment/content-fragments/pe/promotional-cards/ellipse-334-stroke.png'
    },
    tag: {
      title: 'LIMITED TIME OFFER'
    },
    action: {
      type: 'text',
      link: {
        label: 'Enroll Now',
        url: 'https://www.delta.com/mypromos/eligible'
      }
    }
  },
  {
    id: 'complimentaryPreferredSeats',
    type: 'large',
    content: {
      title: 'Complimentary Preferred Seats',
      subtitle:
        'Take 2 Trips in the next 3 months and get Complimentary Preferred Seats for 6 months.'
    },
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/promocards/preferred-seats-promo.jpg',
      alt: 'Complimentary Preferred Seats image'
    },
    image2: {
      alt: 'Complimentary Preferred Seats image',
      show: true,
      src: '/content/dam/nextgen/standard-enrollment/content-fragments/pe/promotional-cards/gradient.png'
    },
    tag: {
      title: 'LIMITED TIME OFFER'
    },
    action: {
      type: 'text',
      link: {
        label: 'Enroll Now',
        url: 'https://www.delta.com/mypromos/eligible'
      }
    }
  },
  {
    id: 'viewAllActivePromotions',
    type: 'large',
    content: {
      title: 'View All Active Promotions',
      subtitle:
        'Check out the promotions you are eligible to enroll in, so you can recap all the benefits of your membership. '
    },
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/promocards/active-promo.jpg',
      alt: 'View All Active Promotions image'
    },
    image2: {
      alt: 'View All Active Promotions image',
      show: true,
      src: '/content/dam/nextgen/standard-enrollment/content-fragments/pe/promotional-cards/gradient.png'
    },
    tag: {
      title: 'LIMITED TIME OFFER'
    },
    action: {
      type: 'caret',
      link: {
        label: '',
        url: 'https://www.delta.com/mypromos/eligible'
      }
    }
  }
];

export const OffersMocks: Offers = {
  cards: CardsMocks,
  disabled: false,
  loaded: true
};
